enum ConnectionStateTypes {
  EXIST = 'exist',
}

export default ConnectionStateTypes;
